import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import Button from '@mui/material/Button';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import DialogMessage from 'components/UI/DialogMessage/DialogMessage';

import { deleteMemory } from 'store/memory-actions';
import { MemoriesDataActions } from 'store/memory-slice';

import classes from './DeleteMemory.module.css';

const DeleteMemory = props => {
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [message] = useState(
    'La Memoria se borrará de manera permanente junto con todos sus comentarios, imágenes y videos relacionados. Esta acción no se puede deshacer.'
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const openMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteMemoryModal = () => {
    setIsDeleting(false);
    setOpenDialog(true);
    handleClose(null);
  };

  const deleteMemoryHandler = () => {
    if (isDeleting) return;
    setIsDeleting(true);
    (async () => {
      try {
        let deleteMemoryData = await deleteMemory(
          props.idMemory,
          props.tributId
        );
        if (deleteMemoryData) {
          // 1. Cerrar el modal inmediatamente
          setOpenDialog(false);

          // 2. Eliminar del store de Redux (para actualizar la pantalla previa)
          dispatch(
            MemoriesDataActions.removeMemory({
              memoryId: props.idMemory,
              tributId: props.tributId
            })
          );

          // 3. Notificar al carrusel / vista previa para remover de la vista actual
          if (typeof props.onDelete === 'function') {
            props.onDelete(props.idMemory);
          }
          if (typeof props.hideMemory === 'function') {
            props.hideMemory(props.idMemory);
          }
          if (typeof props.loadData === 'function') {
            props.loadData();
          }
        } else {
          setOpenDialog(false);
        }
      } catch (err) {
        console.warn('Error al eliminar memoria:', err);
        setOpenDialog(false);
      } finally {
        setIsDeleting(false);
      }
    })();
  };

  const closeDialogHandler = () => {
    if (isDeleting) return;
    setOpenDialog(false);
  };

  return (
    <>
      <Button className={classes.deleteMemoryBtn} onClick={openMenu}>
        <DeleteOutlinedIcon className={classes.icon} />
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem onClick={deleteMemoryModal}>Eliminar</MenuItem>
      </Menu>
      <DialogMessage
        closeDialog={closeDialogHandler}
        action={deleteMemoryHandler}
        open={openDialog}
        message={message}
        title="Eliminar Memoria"
        delete
        disabled={isDeleting}
      />
    </>
  );
};

DeleteMemory.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idMemory: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  tributId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  // eslint-disable-next-line react/require-default-props
  loadData: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  hideMemory: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  onDelete: PropTypes.func
};

export default DeleteMemory;
